export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 0.00195312C21.732 0.00195312 28 6.26998 28 14.002C28 21.7339 21.732 28.002 14 28.002C6.26802 28.002 0 21.7339 0 14.002C0 6.26998 6.26802 0.00195312 14 0.00195312Z"
                fill="#1C74FD"
            />
            <path d="M7 14.002H14H21" stroke="white" strokeWidth="1.6" />
            <path d="M14 7.00195V21.002" stroke="white" strokeWidth="1.6" />
        </svg>
    );
}
